import { path } from '../../Paths';
import { requestMethods } from '../../../../Constants/requestMethods';
import { toJSON } from '../../../../Utils';
import { requestFactory } from '../../RequestFactory';

export const getMemberhsipPlans = () => {
    const url = path.create().getMembershipPlans();

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const addMembershipPlan = data => {
    const url = path.create().addMembershipPlan();

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(data),
    };

    return requestFactory.createRequest(requestConfig);
};

export const updateMembershipPlan = (id, planData) => {
    const url = path.create().updateMembershipPlan(id);

    const requestConfig = {
        url,
        method: requestMethods.POST,
        data: toJSON(planData),
    };

    return requestFactory.createRequest(requestConfig);
};

export const deleteMembershipPlan = id => {
    const url = path.create().deleteMembershipPlan(id);

    const requestConfig = {
        url,
        method: requestMethods.DELETE,
    };

    return requestFactory.createRequest(requestConfig);
};



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/MembershipPlansApi/membershipPlansRequestConfigs.js